const mutations = {
    setNotifications(state, notifications) {
        state.notifications = notifications
    }
}

export default mutations